// PostingTime.jsx
import React from "react";
import { Sun, Cloud, Sunset, Moon, Building } from "lucide-react";

const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const hours = Array.from({ length: 24 }, (_, i) => i);

const getColor = () => {
  const r = Math.random();
  if (r > 0.7) return "bg-primary-300";
  if (r > 0.4) return "bg-primary-100";
  if (r > 0.2) return "bg-secondary-300";
  return "bg-secondary-100";
};

const icons = {
  5: <Sun className="w-3 h-3" />,
  7: <Building className="w-3 h-3" />,
  11: <Sun className="w-3 h-3" />,
  17: <Sunset className="w-3 h-3" />,
  19: <Building className="w-3 h-3" />,
  21: <Cloud className="w-3 h-3" />,
  23: <Moon className="w-3 h-3" />,
};

const PostingTime = () => {
  return (
    <div className="p-2 md:p-4">
      <div className="flex justify-between items-center mb-3 pb-2 border-b border-black-40">
        <h3 className="text-lg font-bold uppercase">Posting Time</h3>
        <p className="text-sm text-black-400">Paris, France · GMT +1:00</p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-separate border-spacing-y-2">
          <tbody>
            {days.map((day, idx) => (
              <tr key={idx} className="align-middle">
                <td className="pr-3 text-black-400 text-xs">{day}</td>
                {hours.map((h) => (
                  <td key={h} className={`w-4 h-1 rounded ${getColor()}`}></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex justify-between mt-2 text-[10px] text-gray-500">
          {hours.map((h) => (
            <div key={h} className="flex flex-col items-center">
              <span className="h-2 w-2 bg-black-900 rounded-full mb-1"></span>
              {icons[h] ? icons[h] : <span>{h % 12 === 0 ? 12 : h % 12}</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostingTime;
